<div class="w-100" fxLayout="column" fxLayoutAlign="start start">
    <div class="common-info-container">
        @for (field of fields; track field.fieldName) {
            <div class="t2 c-primary-gray-600">{{ 'i18n_af_label_field_contact#' + field.fieldName | translate }}</div>
            @if (field.click) {
                <div class="t2 underlined-text c-primary-green-800 pointer"
                     (click)="field.click()">{{ field.fieldValue }}</div>
            } @else {
                <div class="t2 c-primary-gray-900 pre-line">{{ field.fieldValue }}</div>
            }
        }
    </div>
</div>
